const FormField = ({ label, error, htmlFor, children }) => {
  return (
    <div>
      <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
        {label}
      </label>
      {children}
      {error && <p className="text-xs text-red-400 mt-1">{error}</p>}
    </div>
  )
}

export default FormField
